import { RefreshCw } from "lucide-react";
import { Button, Typography } from "top-brains-ui";
import styles from "./QuizLoadError.module.scss";

interface QuizLoadErrorProps {
  title?: string;
  message?: string;
  onRetry: () => void;
  isRetrying?: boolean;
}

const QuizLoadError = ({
  title = "Unable to open the quiz",
  message = "Questions could not be loaded. This is often caused by a slow or interrupted connection. Please retry.",
  onRetry,
  isRetrying = false,
}: QuizLoadErrorProps) => {
  return (
    <div className={styles.wrap} role="alert">
      <Typography className={styles.title}>{title}</Typography>
      <Typography className={styles.message}>{message}</Typography>
      <Button
        type="button"
        onClick={onRetry}
        disabled={isRetrying}
        className={styles.retryBtn}
      >
        <RefreshCw size={16} />
        {isRetrying ? "Retrying..." : "Retry"}
      </Button>
    </div>
  );
};

export default QuizLoadError;
